import {
  Fragment,
  type FC
} from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  Stack,
  styled,
  Divider,
  Typography,
} from '@mui/joy';
import {
  alpha
} from '@mui/system';
import {
  useCountdown
} from '@shared/lib';

dayjs.extend(utc);

const TimeWrapper = styled(Stack)(({
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
}));

const TimeNumber = styled(Typography)(({ theme }) => ({
  fontSize: 9,
  fontStyle: 'normal',
  fontWeight: 600,
  verticalAlign: 'middle',
  color: theme.palette.common.white,
  [theme.breakpoints.down(491)]: {
    fontSize: 8,
  }
}));

const TimeText = styled(Typography)(({ theme }) => ({
  fontSize: 9,
  fontStyle: 'normal',
  fontWeight: 400,
  color: theme.palette.common.white,
  [theme.breakpoints.down(491)]: {
    fontSize: 8,
  }
}));

export type BonusChestTimerProps = {
  endDate: string;
};

export const BonusChestTimer: FC<BonusChestTimerProps> = ({ endDate }) => {
  const timeArray = useCountdown(dayjs.utc(endDate));
  const days = Boolean(timeArray?.[0] || 0);
  return (
    <Stack
      display='grid'
      sx={({ palette, breakpoints }) => ({
        position: 'absolute',
        bottom: -1,
        left: -5,
        zIndex: 2,
        width: 74,
        borderRadius: 8,
        paddingTop: '2px',
        paddingInline: 0.5,
        backgroundColor: palette.common[700],
        gridTemplateColumns: '1fr 6px 1fr 6px 1fr',
        boxShadow: `inset 0 3px 3px 0 ${alpha(palette.common.white, 0.3)}, 0 3px 31px 0 ${alpha(palette.common[700], 0.4)}`,
        [breakpoints.down(491)]: {
          width: 63,
          left: -6,
          bottom: -3,
          gridTemplateColumns: '1fr 5px 1fr 5px 1fr',
        }
      })}>
      {days && (
        <Fragment>
          <TimeWrapper>
            <TimeNumber>{timeArray ? timeArray[0] : 0}</TimeNumber>
            <TimeText>d</TimeText>
          </TimeWrapper>
          <Divider
            orientation='vertical'
            sx={({ palette }) => ({
              height: 13,
              margin: 'auto',
              marginBottom: '2px',
              backgroundColor: palette.common[845],
              boxShadow: `inset 0 3px 3px 0 ${alpha(palette.common.white, 0.3)}`,
            })}
          />
        </Fragment>
      )}
      <TimeWrapper>
        <TimeNumber>{timeArray ? timeArray[1] : 0}</TimeNumber>
        <TimeText>h</TimeText>
      </TimeWrapper>
      <Divider
        orientation='vertical'
        sx={({ palette }) => ({
          height: 13,
          margin: 'auto',
          marginBottom: '2px',
          backgroundColor: palette.common[845],
          boxShadow: `inset 0 3px 3px 0 ${alpha(palette.common.white, 0.3)}`,
        })}
      />
      <TimeWrapper>
        <TimeNumber>{timeArray ? timeArray[2] : 0}</TimeNumber>
        <TimeText>m</TimeText>
      </TimeWrapper>
      {!days && (
        <Fragment>
          <Divider
            orientation='vertical'
            sx={({ palette }) => ({
              height: 13,
              margin: 'auto',
              marginBottom: '2px',
              backgroundColor: palette.common[845],
              boxShadow: `inset 0 3px 3px 0 ${alpha(palette.common.white, 0.3)}`,
            })}
          />
          <TimeWrapper>
            <TimeNumber>{timeArray ? timeArray[3] : 0}</TimeNumber>
            <TimeText>s</TimeText>
          </TimeWrapper>
        </Fragment>
      )}
    </Stack>
  );
};
